export const SUPPORT_URL = 'https://envirosuite.help.ideagen.com/hc/en-gb/p/support';
